import * as React from 'react';
import { Styleable } from '../utils/styles';

export interface CardListProps extends Styleable {
  children: any[];
}

export const CardList = (props: CardListProps) => (
  <div className="flex flex-wrap mv4">{props.children}</div>
);

export default CardList;
